import { Field, Input, makeStyles, Switch, tokens } from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import { Section, SectionColumn } from '@powerportalspro/react-fluent';
import { useState } from 'react';

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Layout.Section.SectionPropertiesDemo';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: tokens.spacingHorizontalL,
  },
  inlineField: {
    flexShrink: 0,
    gridTemplateColumns: 'auto auto',
    '& label': { whiteSpace: 'nowrap' },
  },
  textInput: {
    minWidth: '160px',
  },
});

export function SectionPropertiesSample() {
  const styles = useStyles();
  const t = useT();
  const [sectionBorderVisible, setSectionBorderVisible] = useState(true);
  const [sectionColumnBorderVisible, setSectionColumnBorderVisible] = useState(true);
  const [sectionHeaderText, setSectionHeaderText] = useState('');
  const [sectionColumnHeaderText, setSectionColumnHeaderText] = useState('');
  const [sectionFooterText, setSectionFooterText] = useState('');
  const [sectionColumnFooterText, setSectionColumnFooterText] = useState('');

  return (
    <Section>
      <SectionColumn
        header={
          <div className={styles.toolbar}>
            <Switch
              label={t(`${STRINGS_BASE}.section-border-visible-label`)}
              labelPosition="before"
              checked={sectionBorderVisible}
              onChange={(_, d) => setSectionBorderVisible(d.checked)}
            />
            <Field
              label={t(`${STRINGS_BASE}.section-label`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <Input
                className={styles.textInput}
                value={sectionHeaderText}
                onChange={(_, d) => setSectionHeaderText(d.value)}
              />
            </Field>
            <Field
              label={t(`${STRINGS_BASE}.section-footer-label`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <Input
                className={styles.textInput}
                value={sectionFooterText}
                onChange={(_, d) => setSectionFooterText(d.value)}
              />
            </Field>
            <Switch
              label={t(`${STRINGS_BASE}.section-column-border-visible-label`)}
              labelPosition="before"
              checked={sectionColumnBorderVisible}
              onChange={(_, d) => setSectionColumnBorderVisible(d.checked)}
            />
            <Field
              label={t(`${STRINGS_BASE}.section-column-label`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <Input
                className={styles.textInput}
                value={sectionColumnHeaderText}
                onChange={(_, d) => setSectionColumnHeaderText(d.value)}
              />
            </Field>
            <Field
              label={t(`${STRINGS_BASE}.section-column-footer-label`)}
              orientation="horizontal"
              className={styles.inlineField}
            >
              <Input
                className={styles.textInput}
                value={sectionColumnFooterText}
                onChange={(_, d) => setSectionColumnFooterText(d.value)}
              />
            </Field>
          </div>
        }
      >
        <Section
          headerText={sectionHeaderText}
          footerText={sectionFooterText}
          columnMinWidth="200px"
          borderVisible={sectionBorderVisible}
        >
          <SectionColumn
            headerText={sectionColumnHeaderText}
            footerText={sectionColumnFooterText}
            borderVisible={sectionColumnBorderVisible}
          >
            {t(`${STRINGS_BASE}.column1-label`)}
          </SectionColumn>
          <SectionColumn
            headerText={sectionColumnHeaderText}
            footerText={sectionColumnFooterText}
            borderVisible={sectionColumnBorderVisible}
          >
            {t(`${STRINGS_BASE}.column2-label`)}
          </SectionColumn>
          <SectionColumn
            headerText={sectionColumnHeaderText}
            footerText={sectionColumnFooterText}
            borderVisible={sectionColumnBorderVisible}
          >
            {t(`${STRINGS_BASE}.column3-label`)}
          </SectionColumn>
          <SectionColumn
            headerText={sectionColumnHeaderText}
            footerText={sectionColumnFooterText}
            borderVisible={sectionColumnBorderVisible}
          >
            {t(`${STRINGS_BASE}.column4-label`)}
          </SectionColumn>
        </Section>
      </SectionColumn>
    </Section>
  );
}
